<template>
  <ion-content>
    <ion-grid
      style="height: 100%"
      padding
    >
      <ion-row
        justify-content-center
        align-items-center
        style="height: 100%"
      >
        <div padding>
          <h1>
            {{ title }}
          </h1>
          <p>
            {{ description }}
            {{ tutorial }}
          </p>
          <p
            id="subtext"
            v-html="subtext"
          />
          <ion-button
            color="danger"
            @click="reload"
          >
            {{ buttonText }}
          </ion-button>
        </div>
      </ion-row>
    </ion-grid>
  </ion-content>
</template>

<script>
import { Device } from '@capacitor/device';
import dynamicLink from '@/constants/dynamicLink.js';

export default {
  name: 'OldVersionError',
  data() {
    return {
      title: 'Ollaa aktualisieren',
      description: 'Diese Version von Ollaa ist veraltet.',
      tutorial: 'Lösche deinen Browser Cache und lade die App neu.',
      buttonText: 'App neu laden',
    };
  },
  computed: {
    subtext() {
      let msg = `Deine Version von Ollaa ist: <b>${import.meta.env.VITE_APP_VERSION}</b>. `;
      if (this.currentAppVersion) {
        msg += `Die aktuell Version ist: <b>${this.currentAppVersion}</b>.`;
      }
      return msg;
    },
  },
  props: {
    currentAppVersion: { type: Number, required: false, default: 0 },
  },
  async created() {
    const { platform } = await Device.getInfo();
    if (platform === 'android') {
      this.tutorial = 'Bitte gehe in den Google Play Store und lade die neueste Version herunter.';
      this.buttonText = 'Play Store öffnen';
    }
    if (platform === 'ios') {
      this.tutorial = 'Bitte gehe in den App Store und lade die neueste Version herunter.';
      this.buttonText = 'App Store öffnen';
    }
  },
  mounted() {
  },
  methods: {
    async reload() {
      const { platform } = await Device.getInfo();
      const { dynamicLinkInfo } = dynamicLink();
      if (platform === 'android') {
        const { androidPackageName } = dynamicLinkInfo.androidInfo;
        window.open(`http://play.google.com/store/apps/details?id=${androidPackageName}`);
        return;
      }
      if (platform === 'ios') {
        // const { iosBundleId } = dynamicLinkInfo.iosInfo;
        window.open('https://apps.apple.com/app/id1384284631?mt=8');
        return;
      }
      window.location.reload(true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/typography.scss';

#subtext {
  color: $ollaa-annotation-txt-color;
  font-size: $text-sm;
}
</style>
